/* Publish by EComposer at 2026-11-04 03:33:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5quzgmkc692"]=  window.__ectimmers["ecom-5quzgmkc692"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-5quzgmkc692').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5quzgmkc692', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5quzgmkc692', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-59jqkkac7x').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-59jqkkac7x', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-59jqkkac7x', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rz535kl9vq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rz535kl9vq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rz535kl9vq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zt82axk2s2o').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zt82axk2s2o', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zt82axk2s2o', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zj7ubpen3r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zj7ubpen3r', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zj7ubpen3r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zpx4xkoce7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zpx4xkoce7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zpx4xkoce7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6ljsgsul60j').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6ljsgsul60j', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6ljsgsul60j', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oj6dsuu9jt').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oj6dsuu9jt', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oj6dsuu9jt', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ekaogvr8fh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ekaogvr8fh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ekaogvr8fh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-92nidc1wdzh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-92nidc1wdzh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-92nidc1wdzh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-s91m7tf82om').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-s91m7tf82om', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-s91m7tf82om', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oigfyync29j').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oigfyync29j', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oigfyync29j', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-969dnfrl6b').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-969dnfrl6b', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-969dnfrl6b', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-etlugltwwsf"]=  window.__ectimmers["ecom-etlugltwwsf"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-etlugltwwsf"]["js2j6dq8m"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-etlugltwwsf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-etlugltwwsf', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-etlugltwwsf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-667nbuuez1b').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-667nbuuez1b', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-667nbuuez1b', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0f2s9070z5im').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0f2s9070z5im', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0f2s9070z5im', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qxmasfxgdo"]=  window.__ectimmers["ecom-qxmasfxgdo"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-qxmasfxgdo"]["eqysz7ial"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-qxmasfxgdo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qxmasfxgdo', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qxmasfxgdo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rl460vjou1i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rl460vjou1i', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rl460vjou1i', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-pebyn6jhtv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pebyn6jhtv', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pebyn6jhtv', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-78ww0qgt4l7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-78ww0qgt4l7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-78ww0qgt4l7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qzfdj1pp6r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qzfdj1pp6r', settings: {"link":"custom","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qzfdj1pp6r', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}